import React from 'react';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';
import Carousel from 'nuka-carousel';

const useStyles = makeStyles((theme) => ({
  headingWrapper: {
    padding: '50px 15px 32px',
    maxWidth: 665,
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: '50px 32px 32px',
    },
  },
  sectionTitle: {
    fontSize: 24,
    fontWeight: 600,
    margin: '0 0 20px',
  },
  sectionText: {
    fontSize: 16,
  },
  benefitCardList: {
    display: 'flex',
    maxWidth: 1500,
    margin: '0 auto 60px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 auto 24px',
    },
  },
  mobileSlider: {
    '& .slider-slide': {
      '&:first-child': {
        zIndex: 2,
      },
    },
    '& .slider-control-bottomcenter': {
      bottom: '36px !important',
      '& .paging-item button svg': {
        display: 'none',
      },
      '& .paging-item': {
        marginLeft: 6,
      },
      '& .paging-item button': {
        width: '8px',
        height: '8px',
        borderRadius: '100px',
        opacity: '1 !important',
        backgroundColor: `${theme.specialColors.CIRCULAR_PROGRESS}  !important`,
        padding: 0,
      },
      '& .paging-item.active button': {
        backgroundColor: `${theme.palette.primary.main} !important`,
        width: '18px',
        borderRadius: '50px',
      },
    },
  },
  benefitCard: {
    padding: '36px 56px 68px 42px',
    flex: 1,
    [theme.breakpoints.down('md')]: {
      minHeight: 425,
    },
  },
  cardTitle: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 28,
  },
  cardText: {
    fontSize: 16,
  },
}));

interface BenefitsData {
  title: string;
  text: string;
  background: string;
}

function Benefits({ data }: { data: Array<BenefitsData> }) {
  const isMobile = useSelector((state: RootState) => state.common.platform.isMobile);
  const classes = useStyles();

  return (
    <>
      {isMobile ? (
        <div className={classes.benefitCardList}>
          <Carousel
            className={classes.mobileSlider}
            slideWidth={0.85}
            renderCenterLeftControls={null}
            renderCenterRightControls={null}
            framePadding="0 0 32px"
          >
            {data.map((item) => (
              <BenefitCard
                style={{ minHeight: '390px', backgroundColor: item.background }}
                key={item.title}
                title={item.title}
                text={item.text}
              />
            ))}
          </Carousel>
        </div>
      ) : (
        <div className={classes.benefitCardList}>
          {data.map((item) => (
            <BenefitCard
              key={item.title}
              title={item.title}
              text={item.text}
              style={{ backgroundColor: item.background }}
            />
          ))}
        </div>
      )}
    </>
  );
}

export default Benefits;

function BenefitCard({ title, text, ...otherProps }: any) {
  const classes = useStyles();

  return (
    <div className={classes.benefitCard} {...otherProps}>
      <div className={classes.cardTitle}>{title}</div>
      <div dangerouslySetInnerHTML={{ __html: text }} className={classes.cardText} />
    </div>
  );
}
